/** Current signed-in user from context or persisted session. */
export function resolveAuthUser(contextUser) {
  if (contextUser && (contextUser.id != null || contextUser.email)) {
    return contextUser;
  }
  try {
    const raw = localStorage.getItem('userProfile');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** True when the viewer created / owns the notebook (not a subscriber or collaborator). */
export function isNotebookOwner(summary, user) {
  if (!summary) return false;
  if (summary.ownedByMe === true) return true;
  const ownerId = summary.ownerId ?? summary.owner?.id;
  const userId = user?.id;
  if (ownerId == null || userId == null) return false;
  return String(ownerId) === String(userId);
}
